import React from "react";
import {graphql, useStaticQuery} from "gatsby";

const Organization = () => {
    const { acfTheme } = useStaticQuery(graphql`
        query QueryAcfThemeOrganization {
          acfTheme: wp {
            acfThemeGeneralSettings {
              aCFoptionTemplate {
                footerEnd {
                  facebook
                  instagram
                  tiktok
                  youtube
                  xTwiter
                }
                micromarkup {
                  addresslocality
                  alternatename
                  description
                  email
                  name
                  streetaddress
                  telephone
                  logo {
                    node {
                      localFile {
                        publicURL
                      }
                    }
                  }
                }  
              }
            }
          } 
        }
    `);

    const {footerEnd, micromarkup} = acfTheme.acfThemeGeneralSettings.aCFoptionTemplate;

    // console.log('Organization >>>>>', footerEnd, micromarkup )

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": micromarkup.name, // "Molfar",
        "alternateName": micromarkup.alternatename, // "Видавництво Molfar",
        "url": "https://molfarpublishing.ua/",
        "logo": "https://molfarpublishing.ua" + micromarkup?.logo?.node?.localFile?.publicURL , // "https://molfar-publishing.com/molfar-LOGO.jpg",
        "contactPoint": [
            {
                "@type": "ContactPoint",
                "telephone": micromarkup.telephone , //"+380633717827",
                "contactType": "customer service",
                "areaServed": "UA",
                "availableLanguage": "Ukrainian"
            }
        ],
        "email": [micromarkup.email], // ["2020@molfar-comics.com"],
        "sameAs": [
            footerEnd.facebook, // "https://www.facebook.com/MolfarComics",
            footerEnd.instagram, // "https://www.instagram.com/molfarcomics/",
            footerEnd.xTwiter, // "https://twitter.com/molfarpublisher",
            footerEnd.tiktok,// "https://www.tiktok.com/@molfarpublish",
            footerEnd.youtube, // "https://www.youtube.com/@MolfarShorts"
        ],
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "UA",
            "addressLocality": micromarkup.addresslocality, // "Хмельницький",
            "streetAddress": micromarkup.streetaddress, // "вул. Прибузька, 18"
        }
    };

    return (
        <script
            className='Organization'
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};

export default Organization;
